import {
  getCurrentCorpAccount,
  isCorpTenant,
  REWARDS_BANNER_TEXT,
  useIsTravelApp,
} from "@capone/common";
import { GenericBanner } from "halifax";
import React, { ReactElement, useContext } from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { B2B_PORTAL_BANNER_CONTAINER_ID, CustomerAccountRole } from "redmond";

import {
  PATH_EXCHANGE_FLIGHT_BOOK,
  PATH_EXCHANGE_FLIGHT_CONFIRM,
  PATH_EXCHANGE_FLIGHT_SHOP,
} from "b2b-base/src/utils/urlPaths";
import { config } from "../../api/config";
import { ClientContext } from "../../App";
import { useDeviceTypes } from "../../hooks/useDeviceTypes";
import {
  getRewardsAccounts,
  getRewardsAccountWithLargestEarnBanner,
} from "../../selectors";

export interface IRewardsBannerProps extends RouteComponentProps {}

const defaultProps: Partial<IRewardsBannerProps> = {};

const SHOW_MOBILE_BANNER_PATHS = [
  PATH_EXCHANGE_FLIGHT_SHOP,
  PATH_EXCHANGE_FLIGHT_BOOK,
  PATH_EXCHANGE_FLIGHT_CONFIRM,
].flatMap((path) => [path, `${path}/`]);

const RewardsBanner = (props: IRewardsBannerProps) => {
  const { history } = props;
  const { sessionInfo } = useContext(ClientContext);
  const firstName = sessionInfo?.userInfo?.firstName || "";

  const { matchesMobile } = useDeviceTypes();
  const largestEarnAccount = useSelector(
    getRewardsAccountWithLargestEarnBanner,
  );
  const rewardsAccounts = useSelector(getRewardsAccounts);
  const { isTravelApp } = useIsTravelApp();

  const currentAccount = getCurrentCorpAccount(rewardsAccounts, sessionInfo);

  const rewardsAccount = isCorpTenant(config.TENANT)
    ? currentAccount
    : largestEarnAccount;

  if (!rewardsAccount) return null;

  const {
    earn: {
      hotelsMultiplier: earnRate = "",
      flightsMultiplier: flightEarnRate = "",
    },
    rewardsBalance,
    lastFour = "",
    productDisplayName: productId = "",
  } = rewardsAccount;
  const { currency } = rewardsBalance || {};

  let contentText: string | ReactElement = "";

  if (
    !matchesMobile ||
    SHOW_MOBILE_BANNER_PATHS.includes(history.location.pathname)
  ) {
    contentText = REWARDS_BANNER_TEXT({
      firstName,
      earnRate,
      productId,
      lastFour,
      flightEarnRate,
      currency,
      isPrimary:
        rewardsAccount.customerAccountRole === CustomerAccountRole.Primary,
      tenant: config.TENANT,
    });
  } else {
    contentText = "";
  }

  if (!contentText) return null;
  if (isTravelApp) return null;

  return (
    <GenericBanner
      className="rewards-banner-root"
      containerId={B2B_PORTAL_BANNER_CONTAINER_ID}
      content={contentText}
      isMobile={matchesMobile}
    />
  );
};

RewardsBanner.defaultProps = defaultProps;

export default withRouter(RewardsBanner);
